/**
 * File provides the code for UI of the TagsModal used in Tag Management Page
 * Purpose : Add Update Delete Restore Modal
 */
import { Modal } from "react-bootstrap";
import Service from "../../Service/http";
import { toast } from 'react-toastify'
import { debounce } from 'lodash'
import { useCallback, useState } from "react";
import { BeatLoader, ClipLoader } from 'react-spinners';

export default function TagsModal({ show, onHide, tagName, setTagName, tagDescription, setTagDescription, refetch, setShowDeleted, tagId, refetchAll, action = 'add'}) {

    const service = new Service();

    const [tagAvaillable, setTagAvailable] = useState(true);
    const [loading, setLoading] = useState(false);

    const handleAddTag = async () => {

        try {
            setLoading(true)
            const response = await service.post('api/tags/add', { tagName, tagDescription });
            toast.success(response.message);

        } catch (error) {
            
            console.error(error)
            toast.error(error);

        } finally {
            setTagName('')
            setTagDescription('')
            refetch();
            refetchAll();
            setLoading(false)
            onHide()
        }
    }

    const handleTagNameChange = (e) => {
        setTagName(e.target.value);
        debouncedFetchStatus(e.target.value);
    }

    const debouncedFetchStatus = useCallback(debounce(async (tagName) => {

        try {
            
            if(!tagName) return;

            setLoading(true);
            const response = await service.get(`api/tags/available?tagValue=${tagName.trim().split(' ').join('-').toLowerCase()}`)
            setTagAvailable(response.available);

        } catch (error) {
            
            console.error(error);
            toast.error("Can't fetch availability");

        } finally {
            setLoading(false);
        }
        
    },1000) // Adjust the debounce delay as needed
    , [])

    const handleUpdateTag = async () => {

        try {
            
            setLoading(true);
            const response = await service.put(`api/tags/update/${tagId}`, { tagName, tagDescription });
            toast.success(response.message);
            refetch()
            refetchAll()

        } catch (error) {
            toast.error('Unable to delete Tag')
            console.error(error)
        } finally {
            setTagName('')
            setTagDescription('')
            setLoading(false);
            onHide()
        }
    }

    const handleDeleteOrRestore = async () => {

        try {

            setLoading(true);
            await service.put(`api/tags/${action}/${tagId}`);
            refetch();
            toast.success(`Tag ${action}d!`)

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
            onHide();
        }
    }

    const actionToMethodMap = {
        'add' : handleAddTag,
        'update' : handleUpdateTag,
        'delete' : handleDeleteOrRestore,
        'restore' : handleDeleteOrRestore
    }

    const actionToLabelMap = {
        'add' : 'Add Tag',
        'update' : 'Update Tag',
        'restore' : 'Restore Tag',
        'delete' : 'Delete Tag'
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
      >
        <Modal.Header >
            <Modal.Title>
                <h4 className="text-primary">{actionToLabelMap[action]}</h4>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {
            (action === 'add' || action === 'update') ? (
                <>
                <label htmlFor="tag-name">Tag Name</label>
                <input 
                    type="text" 
                    id="tag-name" 
                    className="form-control my-2" 
                    onChange={(e) => handleTagNameChange(e)}
                    value={tagName}
                />

                <div className="tag-value-container">
                    <span className={`badge bg-${tagAvaillable ? 'primary' : 'danger'} my-2`}>{tagName.split(' ').join('-').toLowerCase()}</span>
                    {loading && <span className="mx-2"><BeatLoader color="#3498db" size={5} /></span>}
                </div>

                <label htmlFor="tag-description">Tag Description</label>
                <textarea  
                    type="text" 
                    id="tag-description" 
                    className="form-control my-2" 
                    onChange={(e) => setTagDescription(e.target.value)}
                    value={tagDescription}
                />
                </>
            ) : (

                <h5>Are you sure you want to {action} tag ? </h5>
            )
        }
            
        </Modal.Body>
        <Modal.Footer>

            <button className="custom-button text-dark" onClick={() => {
                setTagName('')
                setTagDescription('')
                onHide();
            }}>
                Close
            </button>
            <button 
                className={`custom-button text-${((tagName && tagDescription && tagAvaillable) || (action === 'delete' || action === 'restore')) ? 'white' : 'dark'} 
                    bg-${(action === 'delete') ? 'danger' : ((action === 'restore') || (tagName && tagDescription && tagAvaillable)) ? 'success' : 'secondary' }
                    d-flex align-items-center justify-content-center
                `}
                disabled={!((tagName && tagDescription && tagAvaillable) || (action === 'delete' || action === 'restore'))} 
                onClick={ actionToMethodMap[action] }
            >
                {!loading ?  actionToLabelMap[action] : <ClipLoader size={22} color={"white"}/> }
            </button>

        </Modal.Footer>
      </Modal>
    );
  }